import React from "react";
import classes from './Symbol.module.css';

const TickSvg = ({
    width,
    height,
    strokeColor
}) => {


    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={strokeColor} stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
  <path d="M20 6L9 17l-5-5"/>
</svg>


        </>
    )
};

export default TickSvg;
